import StainView from "./StainView";
import MembraneTimeline from "./MembraneTimeline";
import ImageAnnotation from "./ImageAnnotation";

import SearchBar from "./SearchBar";
import O from "./O";
import { useReducer } from 'react';
import { produce } from 'immer';






function Stain(membraneId){
  return [ membraneId ];
}

function Membrane(args){
  return { 
    nextStain:null,
    annotations:[],
    ...args,
  }
}

function MembraneReducer(state,action){
  switch(action.type){

    case "setSelectedAnnotationId":{
      return produce(state, draft => {
        draft.selectedAnnotationId = action._id
      })
    }
    case "setAnnotationClicked":{
      let { pieceId } = action;
      let { selectedAnnotationId } = state;
      let atnId = selectedAnnotationId;

      return produce(state,draft => {
        for(let membraneId in draft.membranes){
          let mem = draft.membranes[membraneId];
          mem.annotations = mem.annotations.filter(x => x!==atnId);
        }
        draft.membranes[pieceId].annotations.push(atnId);
      })

    }
    case "removePiece":{
      let { pieceId,fromStain,from } = action;

      let toRemove = state[pieceId];
      if( toRemove.cuts.length > 0 ){
        ;
        return state;
      }else if( toRemove.nextTop ){
        ;
        return state;
      }else{

        return produce(state,draft => {

          let fromPiece = draft[from];
          if( fromPiece.nextTop === pieceId ){
            fromPiece.nextTop = null;
          }else{
            fromPiece.cuts = fromPiece.cuts.filter(x => x!==pieceId);
          }

          delete draft[pieceId];

        });
      }
    }
    case "addCut":{
      let { newId, to, after } = action;
      return produce(state,draft => {

        draft.stains[to].push(
          newId
        )

        draft.membranes[newId] = Membrane();

      });
    }
    case "addReprobe":{
      let { newStainId, newMembraneId, to, } = action;
      return produce(state,draft => {




        // we are adding a new stain in place of the old
        // the new one points to the current!
        let target =  draft.membranes[to];
        let targetCurrentNextStain = target.nextStain

        //new membrane
        let newMembrane = Membrane({ nextStain:targetCurrentNextStain, })
        draft.membranes[ newMembraneId] = newMembrane;

        //new stain
        draft.stains[newStainId] = Stain(newMembraneId);


        //set old stain to newId
        target.nextStain = newStainId;

      });
    }
    default:{
      throw Error(`Unregistered action "${action.type}".`);
    }
  }
}

/*

  membrane:{
    cuts:[]
  },
  blot:{},


*/

const Stains = {
  root:["m0"],
}

const Membranes = {
  m0:{}
}




/*

  it's a "timepoint/lineage"
  each "point" has a "list of cuts"



*/



const DefaultState = {
  membranes:{
    m0:Membrane(),
  },
  stains:{
    root:["m0"]
  },
  selectedAnnotationId:"TEST_ID",
}





export default function BlotOutlineBuilder(){

  let [ 
    state,
    dispatch
  ] = useReducer(MembraneReducer,DefaultState)


  let ids = ["A","B","C"];






  return (

    <div class="sg-row full-dim">

      <div style={{
        height:'100%',
        borderRight:'1px solid #ccc',
        width:300,

      }}>

      <div class="sg-row">
        {ids.map(id => <button onClick={() => dispatch({
          type:"setSelectedAnnotationId",
          _id:id
        })}>Id = {id}</button>)}
      </div>


      <div>Selected Id: {state.selectedAnnotationId}</div>
      </div>

      <div>

        

        <StainView {...{
          state,
          stainId:"root",
          dispatch,
        }}/>


          <div>
            <pre>
              {JSON.stringify(state,null,1)}
            </pre>
          </div>


      </div>

      {false && <div class="border-left">
        <ImageAnnotation />
        <div class="outline flex-expand">
          Image preview? Annotation spot
        </div>
      </div>}


    </div>

  )

}
